import { Button } from "@shared-ui/button";
import { EmptyState } from "@/components/ui/empty-state";

/**
 * A pending queue whose list request failed. Without this the queue rendered
 * its "nothing waiting" empty state, which reads as an empty queue rather than
 * as a failure.
 */
export function QueueLoadError({
	onRetry,
	isRetrying,
}: {
	onRetry: () => void;
	isRetrying: boolean;
}) {
	return (
		<EmptyState
			title="This queue could not be loaded."
			action={
				<Button variant="outline" onClick={onRetry} isLoading={isRetrying}>
					Try again
				</Button>
			}
		/>
	);
}
